<template>
  <section class="content-padding">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
          <div class="card">
            <div class="card-header">
              <template>
                <h3 class="mb-1">
                  <label>{{ $t('message.operation_feedback.title') }}</label>
                </h3>
                <label> 1 = <span>{{ $t('message.operation_feedback.level01') }}</span> 5 = {{ $t('message.operation_feedback.level05') }}</label>
              </template>
            </div>
            <div class="card-body">
              <div v-if="loading">
                <loader></loader>
              </div>
              <div v-else-if="!completed && allowReview">
                <form @submit.prevent="submitFeedback">
                  <div class="card" v-for="topic in topics" :key="topic">
                    <div class="card-header">
                      <label>{{ $t(`message.sm_feedback.${topic}`) }}</label>
                    </div>
                    <div class="card-body score">
                      {{ $t('message.sm_feedback.level01') }}
                      <label class="radio-inline">
                        <input type="radio" value="1" v-model="submitData[topic]" :name="`${topic}_rating`"> 1
                      </label>
                      <label class="radio-inline">
                        <input type="radio" value="2" v-model="submitData[topic]" :name="`${topic}_rating`"> 2
                      </label>
                      <label class="radio-inline">
                        <input type="radio" value="3" v-model="submitData[topic]" :name="`${topic}_rating`"> 3
                      </label>
                      <label class="radio-inline">
                        <input type="radio" value="4" v-model="submitData[topic]" :name="`${topic}_rating`"> 4
                      </label>
                      <label class="radio-inline">
                        <input type="radio" value="5" v-model="submitData[topic]" :name="`${topic}_rating`" required> 5
                      </label>
                      {{ $t('message.sm_feedback.level05') }}
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-header">
                      <label>{{ $t('message.sm_feedback.user_comment') }}</label>
                    </div>
                    <div class="card-body">
                      <textarea class="form-control" rows="3" v-model="submitData.user_comment"></textarea>
                    </div>
                  </div>
                  <div style="margin-top:0.5em;">
                    <!-- <small class="fa-pull-left mt-3 text-muted">FMOR-01-00</small> -->
                    <button class="btn btn-success fa-pull-right">{{ $t('message.button.submit') }}</button>
                  </div>
                </form>
              </div>
              <div v-else align="center">
                <h3>
                  <label>{{ $t('message.operation_feedback.done') }}</label>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios'
import Loader from '../loader/Loader'
import StarRating from 'vue-star-rating'

export default {
  components: {
    Loader,
    StarRating
  },
  data () {
    return {
      rating: 0,
      comment: '',
      completed: false,
      reportProblem: '',
      reportProblemId: '',
      loading: true,
      saving: false,
      validation: '',
      allowReview: false,
      topics: [
        'clarity_of_communication',
        'accuracy_of_problem_solving',
        'politeness_and_care',
        'speed_of_execution',
        'overall_satisfaction'
      ],
      submitData: {
        clarity_of_communication: '',
        accuracy_of_problem_solving: '',
        politeness_and_care: '',
        speed_of_execution: '',
        overall_satisfaction: '',
        user_comment: ''
      }
    }
  },
  methods: {
    async submitFeedback () {
      this.saving = true
      const { data } = await axios.post(`/report-problem/${this.reportProblemId}`, this.submitData)
      if (!data.error) {
        this.saving = false
        this.completed = true
      }
    },
    async getReportProblem () {
      this.loading = true
      this.reportProblemId = this.$route.query.id
      this.validation = this.$route.query.validation
      const { data } = await axios.get(`/report-problem/${this.reportProblemId}?validation=${this.validation}`)
      if (!data.error) {
        this.allowReview = true
        this.reportProblem = data.report_problem
        if (this.reportProblem.rating_date) {
          this.completed = true
        }
      }
      this.loading = false
    }
  },
  created () {
    // this.checkAuthReview()
    this.getReportProblem()
  }
}
</script>
<style lang="scss" scoped>
.score {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/review/ReviewReportProblem.vue